<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">R.E. Bowden is a Senior Lecturer in Visual Communications at Wolverhampton University, now retired. Robert taught students on a BA (Honours) course in Graphic Design.</p><br/>
<p style="text-indent: 00em;">Outside of his career, he is a keen boater and musician, acting as Musical Director for some ten shows and a member of a band. He has written several folk songs about narrow boating on canals and rivers. He is also a keen modeller and enthusiast for the hobby of model railways.</p><br/>
<p style="text-indent: 00em;">He has now written five novels, including a science fiction comedy and a children’s adventure set in Animal World.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?08f3b039